import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { SocAssessmentQuestionnaireItem } from './questionnaire'
import { ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/AssessmentOverview/questionnaireAnswer'
import { PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/PatientOverview/questionnaireAnswer'
import { DISCHARGE_PLANNING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/DischargePlanning/questionnaireAnswer'
import { MEDICATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/Medications/questionnaireAnswer'
import { SKILLED_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/SkilledNeeds/questionnaireAnswer'
import { ADL_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/ADLNeeds/questionnaireAnswer'
import { FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/FinalSteps/questionnaireAnswer'

export const SOC_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  // Assessment overview
  ...ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Patient overview
  ...PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Medications
  ...MEDICATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Skilled Needs
  ...SKILLED_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // ADL Needs
  ...ADL_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Discharge Planning
  ...DISCHARGE_PLANNING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Authorizations
  [SocAssessmentQuestionnaireItem.AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE]:
    QuestionnaireAnswerType.REFERENCE,
  [SocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_REQUESTED_HOURS]:
    QuestionnaireAnswerType.DECIMAL,

  // Visit scheduling
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE]: QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_WAKEUP_TIME]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_BEDTIME]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_DAY]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_NAME]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_REPEATS_ON_DAY]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_SPLIT_CAREGIVERS]:
    QuestionnaireAnswerType.BOOLEAN,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_SPLIT_PRIMARY_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_ENABLED]:
    QuestionnaireAnswerType.BOOLEAN,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_DAY]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VALID]:
    QuestionnaireAnswerType.BOOLEAN,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_WEEKDAY]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_CHANGE_REASON]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_ADDITIONAL_NOTES]:
    QuestionnaireAnswerType.STRING,

  // Plan of Care
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_GOALS_GOAL]: QuestionnaireAnswerType.INTEGER,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO]:
    QuestionnaireAnswerType.GROUP,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INTERVENTION]:
    QuestionnaireAnswerType.INTEGER,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_CATEGORY]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_GOAL]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TASK]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INDICATION]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TYPE]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INSTRUCTION]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_PATIENT_CENTERED_GOAL]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_ADDITIONAL_DETAILS]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_VISITS]:
    QuestionnaireAnswerType.INTEGER,
  [SocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_FREQUENCY]:
    QuestionnaireAnswerType.STRING,

  // Supervisory review
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_ID_BADGE]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_HONORING_RIGHTS]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_EMERGENCY_PROTOCOL]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_HYGIENE_PRECAUTIONS]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_REPORTING_CHANGES]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_GRIEVANCE_COMPLAINT]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_POC_DOC_REVIEWED_WITH_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_PPE_ACCESS]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_SUPERVISION_OBSERVED]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_TASK_OBSERVED]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_PATIENT_STATUS]:
    QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_COMMENTS]: QuestionnaireAnswerType.STRING,

  // Narrative background
  [SocAssessmentQuestionnaireItem.NARRATIVE_BACKGROUND]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.NARRATIVE_SYSTEM_SUMMARIES]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_OVERVIEW]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.NARRATIVE_SKILLED_NEEDS]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.NARRATIVE_ADL_NEEDS]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.NARRATIVE_CARE_COORDINATION]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.NARRATIVE_PATIENT_SERVICES]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.NARRATIVE_PATIENT_GOALS]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_EDUCATION]: QuestionnaireAnswerType.STRING,
  [SocAssessmentQuestionnaireItem.NARRATIVE_FINAL_NOTES]: QuestionnaireAnswerType.STRING,

  // Final steps
  ...FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE
}
